import React from "react";
import FlightDetailsAncillaryItem from "../../../../components/elements/FlightDetailsAncillaryItem/FlightDetailsAncillaryItem.js";
import { HealthInsuranceIcon } from "@bookingcom/bui-assets-react/streamline";
import useInsuranceItemController from "./useInsuranceItem.controller.js";
import { FlightDetailsInfoDesktopUI } from "../../../../components/ui/FlightDetails/index.js";
import { customGoal } from "@flights/et-universal";
export default function InsuranceItemDesktop(props) {
    const { description, insurancePriceCopy, showLoadingPrice, title } = useInsuranceItemController(props);
    customGoal("flights_strategy_manager_suppress_insurance_non_eur_zone_pos_switch", 2);
    return (React.createElement(FlightDetailsInfoDesktopUI.Item, { svg: HealthInsuranceIcon, inclusionType: "EXTRA" },
        React.createElement(FlightDetailsAncillaryItem, { title: title, renderTextOnly: true, type: "travelInsurance", description: description, icon: HealthInsuranceIcon, priceCopy: insurancePriceCopy, showLoadingPrice: showLoadingPrice })));
}
